var testValue = {

	/**
	 * Init event listeners
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		if (window.app.environment !== 'live') {

			document.addEventListener('keyup', function(event) {
				if ((event.ctrlKey && event.altKey && event.shiftKey && event.code === 'KeyT') || (event.altKey && event.shiftKey && event.code === 'KeyY') || (event.altKey && event.shiftKey && event.code === 'KeyT')) {
					testValue.applyTestValues(target);
				}
			});

		}

	},

	/**
	 * Functie om test values toe te passen op velden
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	applyTestValues: function(target) {

		target.querySelectorAll('[data-test-values]').forEach((el) => {
			try {
				const values = JSON.parse(el.getAttribute('data-test-values'));
				el.value = values[Math.floor(Math.random() * values.length)];
				el.dispatchEvent(new CustomEvent('blur'));
			} catch (e) {
				if (e instanceof SyntaxError) {
					console.warn('Invalid JSON in data-test-values attribute:', e);
				} else {
					console.warn('Error applying test value:', e);
				}
			}
		});

	}

};

export default testValue;
